import { createFileRoute } from '@tanstack/react-router'

import { WorkspacePickerPage } from '@/features/account/pages/workspace-picker-page'

/** A1 — Workspace picker (pre-console). */
export const Route = createFileRoute('/_ws/workspaces/')({
  component: WorkspacePickerPage,
})
